// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { MessageFeedTemplate } from 'models/shared.models';
import { ASSETS } from '../../../../../../assets/assets';
import { MessageFeedbackComponent } from '../../../../message-feedback/message-feedback.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../../popup-feedback/popup-feedback.directive';
import { TableSecondaryComponent } from '../../../../table-secondary/table-secondary.component';
import { EntityFieldsComponent } from '../../sub-form/entity-fields/entity-fields.component';
import { ClaimService } from '../claim.service';
import { getField } from '../helpers/data-values';
import { validateFields } from '../helpers/validate';
import { fieldList } from './../claim.fields';

@Component({
  selector: 'lbca-claim-phase',
  templateUrl: './claim-phase.component.html',
  styleUrl: '../../sub-form/subform.component.scss',
  imports: [MessageFeedbackComponent, EntityFieldsComponent, TableSecondaryComponent],
})
export class ClaimPhaseComponent implements OnInit {
  readonly assets = inject(ASSETS);
  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );
  @ViewChild('templateStepRegistered') templateStepRegistered!: TemplateRef<any>;

  @ViewChild('desmarcarTodos', { static: true }) desmarcarTodos!: ElementRef;
  @ViewChild('marcarTodos', { static: true }) marcarTodos!: ElementRef;

  public claimLabelsDict: Object | any = {};

  public submitButtonRegisterPhase: boolean = false;

  public checkMark: 'all' | 'none' | 'almost' = 'all';

  public checkedItens: string[] = [];

  private fieldList: any = fieldList;

  public getFieldv: any = getField();

  public loading: any = true;

  public messageFeedObject: MessageFeedTemplate = {
    primary: '',
    secondary: '',
    emoji: '',
    type: 'danger',
    show: false,
    autoclose: true,
  };

  public table: any = [];

  @Input() taskId!: string;
  @Input() userId!: string;
  @Input() processId!: string;
  @Input() currentLegalRequest: any;
  @Input() removeSteps: any;
  @Input() field: any;

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Output('realoadDataOutput') realoadDataEmmitter = new EventEmitter();
  @Output('closeModalOutput') closeModalEmmitter = new EventEmitter();

  public msgRegistrerNewPhase: string = '';

  constructor(private claimService: ClaimService, private overlay: Overlay) {}
  public selectNewPhase: any = {
    label: 'Fase',
    error: [],
    required: true,
    labeled: false,
    contentEditable: true,
    entityKey: 'selectNewPhase',
    keySort: 'id',
    auxEntity: {
      listOptions: [],
    },
    value: null,
  };
  ngOnInit(): void {
    this.claimLabelsDict = this.assets.labels.components.claim;
    this.msgRegistrerNewPhase = this.claimLabelsDict['registerNewPhase'].split('|');
    setTimeout(() => {
      this.constructModalTable();
      setTimeout(() => this.checkAll('all'), 100);
    }, 100);
    const taskId = this.taskId;
    const userId = localStorage.getItem('user-id');
    const processId = this.processId;
    const flowId = this.cardInfo.flowId;
    const params = {
      taskId,
      processId,
      userId,
      flowId,
    };
    this.loading = true;
    this.claimService.getStepDropDown(params).subscribe((response: any) => {
      this.selectNewPhase = {
        ...this.selectNewPhase,
        auxEntity: {
          listOptions: response.map((item) => ({
            value: item.id,
            label: item.label,
          })),
        },
      };
      this.loading = false;
    });

    this.claimService.getStepDropDown(params).subscribe((response: any) => {
      this.selectNewPhase = {
        ...this.selectNewPhase,
        auxEntity: {
          listOptions: response.map((item) => ({
            value: item.id,
            label: item.label,
          })),
        },
      };
      this.loading = false;
    });
  }

  public filterDateAccordingToRegisteredOptions() {
    return this.removeSteps.map((i) => String(i.phaseId));
  }

  public createStep() {
    const taskId = this.taskId;
    const userId = this.userId;
    const processId = this.processId;
    const params = {
      taskId,
      processId,
      userId,
    };

    if (validateFields(['selectNewPhase'])) return;

    const phase = this.getFieldv['selectNewPhase'];

    let body: any = { label: phase.labelValue, phaseId: phase.value };

    if (this.checkedItens.length > 0) {
      const legalRequests = this.currentLegalRequest.legalRequests.filter((item) =>
        this.checkedItens.find((checkedPhases) => checkedPhases === item.id)
      );
      const lr = JSON.parse(JSON.stringify(legalRequests));
      lr.forEach((legalreq) => {
        legalreq.parent = legalreq.id;
        legalreq.dateReference = legalreq.dateReference || null;
        legalreq.primaryValue = legalreq.primaryValue
          ? parseFloat(legalreq.primaryValue).toFixed(2)
          : null;
        legalreq.interestDateReference = legalreq.interestDateReference || null;
      });

      body = { ...body, legalRequests: lr };
    }
    this.submitButtonRegisterPhase = true;

    this.claimService.step(body, params).subscribe(
      async (response: any) => {
        if (response.errors) {
          this.submitButtonRegisterPhase = false;
          this.defautlFeedbackServerError(response.errors);
          return;
        }
        this.showStepRegisteredPopup();
        this.realoadDataEmmitter.emit(true);
        this.closeModalEmmitter.emit(true);
        this.submitButtonRegisterPhase = false;
      },
      (err: any) => {
        this.submitButtonRegisterPhase = false;
        this.defautlFeedbackServerError(err);
      }
    );
  }

  public closeModal() {
    this.closeModalEmmitter.emit(true);
  }

  public changeCheckedItens(obj) {
    if (obj.operation === 'remove')
      this.checkedItens = this.checkedItens.filter((value) => value !== obj.id);
    else this.checkedItens.push(obj?.id);

    const allItens =
      this.currentLegalRequest && this.currentLegalRequest.legalRequests
        ? this.currentLegalRequest.legalRequests.length
        : 0;
    const checked = this.checkedItens.length;

    if (checked === 0) {
      this.checkMark = 'none';
      return;
    }

    if (checked === allItens) {
      this.checkMark = 'all';
      return;
    }

    this.checkMark = 'almost';
  }

  public checkAll(ev: 'all' | 'none' | 'almost') {
    this.checkMark = ev;
    if (this.currentLegalRequest) {
      if (ev === 'all')
        this.checkedItens =
          this.currentLegalRequest && this.currentLegalRequest.legalRequests
            ? this.currentLegalRequest.legalRequests.map((i) => i.id)
            : [];
      if (ev === 'none') this.checkedItens = [];
    }
  }

  public changeLabelValueNewClaim($event, field) {
    field.labelValue = $event;
  }

  public changeValueNewClaim($event, field) {
    field.value = $event;
    field.error = [];
  }

  public closeFeed(): void {
    this.messageFeedObject.show = false;
  }

  private defautlFeedbackServerError(error): boolean {
    this.setFeedback(
      this.claimLabelsDict['error-server-primary'],
      this.claimLabelsDict['error-server-secondary'],
      'emoji--expressionless',
      'danger'
    );
    return false;
  }

  private setFeedback(
    primary: string,
    secondary: string,
    emoji: string,
    type: 'danger' | 'warning' | 'success',
    autoclose = true
  ): void {
    this.messageFeedObject.primary = primary;
    this.messageFeedObject.secondary = secondary;
    this.messageFeedObject.emoji = emoji;
    this.messageFeedObject.type = type;
    this.messageFeedObject.autoclose = autoclose;
    this.messageFeedObject.show = true;
  }

  private constructModalTable() {
    const fieldsListTable = this.fieldList;
    const cols: any[] = [];
    const colsSec: any[] = [];

    if (fieldsListTable && fieldsListTable.primary)
      fieldsListTable.primary.forEach((element, index) => {
        const obj: any = {
          name: element.entityKey,
          label: element.label,
          type: 'data',
          orderDefault: index === 1 ? true : false,
          order: false,
          col: element.size,
          field: element,
        };

        if (index === 0) obj.templateFooter = this.marcarTodos;
        if (index === 1) obj.templateFooter = this.desmarcarTodos;

        cols.push(obj);
      });

    cols.push({
      name: 'details',
      label: '',
      type: 'details-table',
      col: 1,
    });

    if (fieldsListTable && fieldsListTable.secondary)
      fieldsListTable.secondary.forEach((element, index) => {
        const obj = {
          name: element.entityKey,
          label: element.label,
          type: 'data',
          orderDefault: index === 1 ? true : false,
          order: false,
          col: element.size,
          field: element,
        };

        colsSec.push(obj);
      });

    const body =
      this.currentLegalRequest && this.currentLegalRequest.legalRequests
        ? JSON.parse(JSON.stringify(this.currentLegalRequest.legalRequests))
        : [];
    this.table = {
      config: {
        highlight: () => {
          return true;
        },
      },
      columns: cols,
      details: colsSec,
      body,
    };
  }

  public showStepRegisteredPopup(): void {
    this.popupFeedController.autoclose = 4000;
    this.popupFeedController.show(this.templateStepRegistered);
  }
}
